import { motion } from "framer-motion";
import { ReactNode } from "react";

type MotionLazyScrollProps = {
    children: ReactNode;
    className?: string;
};

export const MotionLazyScroll = ({ children, className } : MotionLazyScrollProps) => {
    const initial = { opacity: 0, y: 20 };
    const whileInView = { opacity: 1, y: 0 };
    const transition = { duration: 0.6 };
    const viewport = { once: true, amount: 0.1 };

    const props = { initial, whileInView, transition, viewport };

    return (
        <motion.div {...props} className={className}>
            {children}
        </motion.div>
    );
};